import Vue from 'vue'
import Router from 'vue-router'

// 解决错误：Uncaught (in promise) NavigationDuplicated: Avoided redundant navigation to current location: "/".
// 加入如下代码 start
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// end

Vue.use(Router)

export default new Router({
  // mode:'history',
  routes: [{
    path: '/',
    name: 'jlb_login',
    component: resolve => require(['@/components/julebu/login/login'], resolve),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/jlb_main',
    name: 'jlb_main',
    component: resolve => require(['@/components/julebu/main'], resolve),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/jlb_xilie',
    name: 'jlb_xilie',
    component: resolve => require(['@/components/julebu/xilie/index'], resolve),
    meta: {
      title: '设计指南'
    }
  },
  {
    path: '/jlb_xiliedata',
    name: 'jlb_xiliedata',
    component: resolve => require(['@/components/julebu/xilie/xilie_data'], resolve),
    meta: {
      title: '设计指南详情'
    }
  },
  {
    path: '/jlb_nxilie',
    name: 'jlb_nxilie',
    component: resolve => require(['@/components/julebu/nxilie/index'], resolve),
    meta: {
      title: '系列图库'
    }
  },
  {
    path: '/jlb_nxiliedata',
    name: 'jlb_nxiliedata',
    component: resolve => require(['@/components/julebu/nxilie/xilie_data'], resolve),
    meta: {
      title: '系列图库详情'
    }
  },
  {
    path: '/jlb_anlilist',
    name: 'jlb_anlilist',
    component: resolve => require(['@/components/julebu/anli/index'], resolve),
    meta: {
      title: '经典案例'
    }
  },
  {
    path: '/jlb_anlidata',
    name: 'jlb_anlidata',
    component: resolve => require(['@/components/julebu/anli/anli_data'], resolve),
    meta: {
      title: '经典案例详情'
    }
  },
  {
    path: '/jlb_finedesignlist',
    name: 'jlb_finedesignlist',
    component: resolve => require(['@/components/julebu/fine_design/index'], resolve),
    meta: {
      title: '精品设计'
    }
  },
  {
    path: '/jlb_finedesigndata',
    name: 'jlb_finedesigndata',
    component: resolve => require(['@/components/julebu/fine_design/finedesign_data'], resolve),
    meta: {
      title: '精品设计详情'
    }
  },
  {
    path: '/jlb_cailiao',
    name: 'jlb_cailiao',
    component: resolve => require(['@/components/julebu/cailiao/index'], resolve),
    meta: {
      title: '材料图库'
    }
  },
  {
    path: '/jlb_lycailiao',
    name: 'jlb_lycailiao',
    component: resolve => require(['@/components/julebu/cailiao/luoya'], resolve),
    meta: {
      title: '罗亚材料图库'
    }
  },
  {
    path: '/jlb_cad',
    name: 'jlb_cad',
    component: resolve => require(['@/components/julebu/cadtuku/index'], resolve),
    meta: {
      title: '展厅图库'
    }
  },
  {
    path: '/jlb_caddata',
    name: 'jlb_caddata',
    component: resolve => require(['@/components/julebu/cadtuku/caddata'], resolve),
    meta: {
      title: '展厅图库详情'
    }
  },
  {
    path: '/jlb_manual',
    name: 'jlb_manual',
    component: resolve => require(['@/components/julebu/manual/index'], resolve),
    meta: {
      title: '技术资料'
    }
  },
  {
    path: '/jlb_manualdata',
    name: 'jlb_manualdata',
    component: resolve => require(['@/components/julebu/manual/manual_data'], resolve),
    meta: {
      title: '设计手册'
    }
  },
  {
    path: '/jlb_manualyd',
    name: 'jlb_manualyd',
    component: resolve => require(['@/components/julebu/manual/manual_datayd'], resolve),
    meta: {
      title: '设计手册'
    }
  },
  {
    path: '/jlb_detailpassword',
    name: 'jlb_detailpassword',
    component: resolve => require(['@/components/julebu/login/detailpassword'], resolve),
    meta: {
      title: '修改密码'
    }
  },
  {
    path: '/jlb_jianjie',
    name: 'jlb_jianjie',
    component: resolve => require(['@/components/julebu/jianjie/index'], resolve),
    meta: {
      title: '简介'
    }
  },
  {
    path: '/jlb_jdsc',
    name: 'jlb_jdsc',
    component: resolve => require(['@/components/julebu/jdsucai/index'], resolve),
    meta: {
      title: '基地素材'
    }
  },
  {
    path: '/jlb_waijingimg',
    name: 'jlb_waijingimg',
    component: resolve => require(['@/components/julebu/jdsucai/sucaiimg'], resolve),
    meta: {
      title: '外景照片'
    }
  },
  {
    path: '/jlb_jidiimg',
    name: 'jlb_jidiimg',
    component: resolve => require(['@/components/julebu/jdsucai/sucaiimg'], resolve),
    meta: {
      title: '基地照片'
    }
  },
  {
    path: '/jlb_qitaimg',
    name: 'jlb_qitaimg',
    component: resolve => require(['@/components/julebu/jdsucai/sucaiimg'], resolve),
    meta: {
      title: '其他照片'
    }
  },
  {
    path: '/jlb_pingpaivadio',
    name: 'jlb_pingpaivadio',
    component: resolve => require(['@/components/julebu/jdsucai/sucaivadio'], resolve),
    meta: {
      title: '品牌视频'
    }
  },
  {
    path: '/jlb_qitavadio',
    name: 'jlb_qitavadio',
    component: resolve => require(['@/components/julebu/jdsucai/sucaivadio'], resolve),
    meta: {
      title: '其他视频'
    }
  },
  {
    path: '/jlb_pingpaivadiob',
    name: 'jlb_pingpaivadiob',
    component: resolve => require(['@/components/julebu/jdsucai/vadio'], resolve),
    meta: {
      title: '品牌视频'
    }
  },
  {
    path: '/jlb_qitavadiob',
    name: 'jlb_qitavadiob',
    component: resolve => require(['@/components/julebu/jdsucai/vadio'], resolve),
    meta: {
      title: '其他视频'
    }
  },
  {
    path: '/jlb_pdflist',
    name: 'jlb_pdflist',
    component: resolve => require(['@/components/julebu/manual/pdflist'], resolve),
    meta: {
      title: '小概念pdf列表'
    }
  },
  {
    path: '/jlb_xgnpdf',
    name: 'jlb_xgnpdf',
    component: resolve => require(['@/components/julebu/manual/xgnpdf'], resolve),
    meta: {
      title: '小概念pdf'
    }
  },
  {
    path: '/jlb_changjianwenti',
    name: 'jlb_changjianwenti',
    component: resolve => require(['@/components/julebu/manual/changjianwenti'], resolve),
    meta: {
      title: '常见设计问题'
    }
  },
  {
    path: '/jlb_jiancepdf',
    name: 'jlb_jiancepdf',
    component: resolve => require(['@/components/julebu/manual/jiancepdf'], resolve),
    meta: {
      title: '检测报告'
    }
  },
  {
    path: '/jlb_cankaolist',
    name: 'jlb_cankaolist',
    component: resolve => require(['@/components/julebu/cankao/index'], resolve),
    meta: {
      title: '参考图库'
    }
  },
  {
    path: '/jlb_cankao',
    name: 'jlb_cankao',
    component: resolve => require(['@/components/julebu/cankao/cankao_data'], resolve),
    meta: {
      title: '参考图库详情'
    }
  },
  {
    path: '/jlb_zhishichanquan',
    name: 'jlb_zhishichanquan',
    component: resolve => require(['@/components/julebu/manual/zhishichanquan'], resolve),
    meta: {
      title: '知识产权'
    }
  },
  {
    path: '/jlb_kaoshi',
    name: 'jlb_kaoshi',
    component: resolve => require(['@/components/julebu/kaoshi/kaoshi'], resolve),
    meta: {
      title: '新品历练'
    }
  },
  {
    path: '/jlb_avatar',
    name: 'jlb_avatar',
    component: resolve => require(['@/components/julebu/login/xiugaitouxiang'], resolve),
    meta: {
      title: '修改头像'
    }
  },
  {
    path: '/jlb_kaoshi_tongji',
    name: 'jlb_kaoshi_tongji',
    component: resolve => require(['@/components/julebu/kaoshi/kaoshitongji'], resolve),
    meta: {
      title: '考试统计'
    }
  },
  {
    path: '/jlb_baobiao',
    name: 'jlb_baobiao',
    component: resolve => require(['@/components/julebu/baobiao/index'], resolve),
    meta: {
      title: '管理报表'
    }
  },
  {
    path: '/my_dingdan',
    name: 'my_dingdan',
    component: resolve => require(['@/components/julebu/mydingdan/index'], resolve),
    meta: {
      title: '我的订单'
    }
  },
  {
    path: '/my_xiangce',
    name: 'my_xiangce',
    component: resolve => require(['@/components/julebu/mydingdan/xiangce'], resolve),
    meta: {
      title: '我的相册'
    }
  },
  {
    path: '/space_scheme',
    name: 'space_scheme',
    component: resolve => require(['@/components/julebu/space_scheme/index'], resolve),
    meta: {
      title: '720°全景库'
    }
  },
  {
    path: '/space_scheme_data',
    name: 'space_scheme_data',
    component: resolve => require(['@/components/julebu/space_scheme/space_scheme_data'], resolve),
    meta: {
      title: '720°全景库'
    }
  },
  // 2023-07-11 代设计页面
  {
    path: '/apply_design/:crmId',
    name: 'apply_design',
    component: resolve => require(['@/components/julebu/apply_design/index'], resolve),
    meta: {
      title: '申请设计'
    }
  },

  // 2023-09-01 网站浏览量统计页面
  {
    path: '/pv_chart',
    name: 'pv_chart',
    component: resolve => require(['@/components/julebu/pv_chart/index'], resolve),
    meta: {
      title: '网站统计'
    }
  },

  // 2023-12-01 设计师详情
  {
    path: '/designer_info/:id/:orderType',
    name: 'designer_info',
    component: resolve => require(['@/components/julebu/designer_info/index'], resolve),
    meta: {
      title: '设计师'
    }
  }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js